import { useContext } from 'react'

import { useRouter } from '@tanstack/react-router'
import { useConfirmation } from 'ui/components/Dialog/ConfirmationDialogV2'
import { useDelete } from '~bank-bsa-reporting/hooks/batch'

import { CTRBatchesChosenItemsContext } from '../context/CTRBatchesChosenItemsContext'

export const useCTRBatchDeleteConfirmation = () => {
  const router = useRouter()

  const confirmation = useConfirmation()
  const { chosenItemsIdList, resetChosenItemsList } = useContext(CTRBatchesChosenItemsContext)

  const { mutateAsync: deleteBatch } = useDelete()

  const handleDelete = async (id: number | null = null) => {
    let singleItemToDelete: number | null = null

    if (id || chosenItemsIdList?.length === 1) {
      if (chosenItemsIdList && chosenItemsIdList[0]) {
        singleItemToDelete = chosenItemsIdList[0]
      } else {
        singleItemToDelete = id
      }
    }

    if (
      await confirmation.showDeleteConfirmation({
        message: (
          <>
            Are you sure you want to delete <i>{singleItemToDelete ? singleItemToDelete : 'these'}</i> Batch(es)?
          </>
        ),
        confirmCallback: () => deleteBatch(id ? [id] : chosenItemsIdList ? chosenItemsIdList : [])
      })
    ) {
      if (resetChosenItemsList) {
        resetChosenItemsList()
      }
      await router.invalidate()
    }
  }

  return {
    handleDelete
  }
}
